import TrendStatusHelper from "../UniversalTable/RendererHelpers/TrendStatusHelper";

export class BreakoutBreakdownTrendStatus {
  static UPTREND_CONTINUATION = "uptrend_continuation";
  static UPTREND_RETURN = "uptrend_return";
  static UPTREND_CONFIRMATION = "uptrend_confirmation";
  static DOWNTREND_NEGATION = "downtrend_negation";
  static DOWNTREND_CONTINUATION = "downtrend_continuation";
  static DOWNTREND_RETURN = "downtrend_return";
  static DOWNTREND_CONFIRMATION = "downtrend_confirmation";
  static UPTREND_NEGATION = "uptrend_negation";
}

export const BREAKOUT_BREAKDOWN_MARKER_COLORS = {
  GREEN: TrendStatusHelper.arrowColors.green,
  RED: TrendStatusHelper.arrowColors.red,
  BROWN: TrendStatusHelper.arrowColors.brown
};

export const BREAKOUT_BREAKDOWN_MARKER_POSITIONS = {
  BELOW_CANDLE: "low",
  ABOVE_CANDLE: "high"
};

export const BREAKOUT_BREAKDOWN_MARKER_SHAPES = {
  UP: "↗",
  DOWN: "↘"
};

const getTooltipTranslationKey = trendStatus => `trend_status_${trendStatus}`;

export const breakoutBreakdownByTrendStatus = {
  [BreakoutBreakdownTrendStatus.UPTREND_CONTINUATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.UP,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.GREEN,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.BELOW_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.UPTREND_CONTINUATION
    )
  },
  [BreakoutBreakdownTrendStatus.UPTREND_RETURN]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.UP,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.GREEN,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.BELOW_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.UPTREND_RETURN
    )
  },
  [BreakoutBreakdownTrendStatus.UPTREND_CONFIRMATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.UP,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.GREEN,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.BELOW_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.UPTREND_CONFIRMATION
    )
  },
  [BreakoutBreakdownTrendStatus.DOWNTREND_NEGATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.UP,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.BROWN,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.BELOW_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.DOWNTREND_NEGATION
    )
  },
  [BreakoutBreakdownTrendStatus.DOWNTREND_CONTINUATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.DOWN,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.RED,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.ABOVE_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.DOWNTREND_CONTINUATION
    )
  },
  [BreakoutBreakdownTrendStatus.DOWNTREND_RETURN]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.DOWN,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.RED,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.ABOVE_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.DOWNTREND_RETURN
    )
  },
  [BreakoutBreakdownTrendStatus.DOWNTREND_CONFIRMATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.DOWN,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.RED,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.ABOVE_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.DOWNTREND_CONFIRMATION
    )
  },
  [BreakoutBreakdownTrendStatus.UPTREND_NEGATION]: {
    shape: BREAKOUT_BREAKDOWN_MARKER_SHAPES.DOWN,
    color: BREAKOUT_BREAKDOWN_MARKER_COLORS.BROWN,
    position: BREAKOUT_BREAKDOWN_MARKER_POSITIONS.ABOVE_CANDLE,
    tooltipTranslationKey: getTooltipTranslationKey(
      BreakoutBreakdownTrendStatus.UPTREND_NEGATION
    )
  }
};

export const getBreakoutBreakdownMarkerSpec = trendStatus =>
  breakoutBreakdownByTrendStatus[trendStatus] ?? null;

export const filterBreakoutBreakdownPoints = points =>
  (points ?? []).filter(point => {
    const trendStatus = point?.trend_status;

    return Boolean(trendStatus && getBreakoutBreakdownMarkerSpec(trendStatus));
  });
